import { CHARACTER_VISIBILITY } from "@next-platform/client-common-core/utils/sharedTypes";

import type { IDraftGroupCharacter } from "@/types";

type GroupChatRequest = Required<
  Pick<
    IDraftGroupCharacter,
    "avatar_url" | "definition_visible" | "greeting" | "guidelines" | "name" | "persona" | "scenario" | "sub_character_ids" | "tags" | "title"
  >
> &
  Pick<IDraftGroupCharacter, "type"> &
  Partial<Record<"greeting_character_id", string | null>> & {
    visibility: CHARACTER_VISIBILITY;
    submitForManualReview?: boolean;
  };

type BuildGroupChatRequestParams = {
  draftGroupCharacter: IDraftGroupCharacter;
  includeClearedGreetingCharacter: boolean;
  includeType: boolean;
  submitForManualReview: boolean;
};

const buildGroupChatRequest = ({
  draftGroupCharacter,
  includeClearedGreetingCharacter,
  includeType,
  submitForManualReview,
}: BuildGroupChatRequestParams): GroupChatRequest => {
  const groupChatRequest: GroupChatRequest = {
    avatar_url: draftGroupCharacter.avatar_url || "",
    definition_visible: draftGroupCharacter.definition_visible ?? false,
    greeting: draftGroupCharacter.greeting || "",
    guidelines: draftGroupCharacter.guidelines ?? false,
    name: draftGroupCharacter.name || "",
    persona: draftGroupCharacter.persona || "You are a helpful assistant.",
    scenario: draftGroupCharacter.scenario || "",
    sub_character_ids: draftGroupCharacter.sub_character_ids || [],
    tags: draftGroupCharacter.tags || [],
    title: draftGroupCharacter.title || "",
    visibility: draftGroupCharacter.visibility as CHARACTER_VISIBILITY,
    submitForManualReview: submitForManualReview || undefined,
  };

  if (includeType) {
    groupChatRequest.type = draftGroupCharacter.type || "";
  }

  const greetingCharacterId = draftGroupCharacter.greeting_character_id;

  if (typeof greetingCharacterId === "string" && greetingCharacterId.length > 0) {
    groupChatRequest.greeting_character_id = greetingCharacterId;
  }

  if (greetingCharacterId === null && includeClearedGreetingCharacter) {
    groupChatRequest.greeting_character_id = null;
  }

  return groupChatRequest;
};

export default buildGroupChatRequest;
